import { put, select, takeEvery } from 'redux-saga/effects'
import * as Sentry from '@sentry/browser'
import i18next from 'i18next'
import imageNameNormalizer from 'helpers/imageNameNormalizer'

import { confirmRewriteImageTrigger, setImageForReplace, setIsButtonDisable } from 'store/entities/gallery/actions'
import { getGalleryActivitiesImages } from 'store/entities/gallery/selectors'
// @ts-ignore
import { showError, showWarning } from 'store/entities/toastr/utils/index.js'
import { ACTIVITY_DEFAULT_IMAGE_MESSAGE } from 'app/constants/activity'

export default function* checkImageNameSaga() {
  yield takeEvery(confirmRewriteImageTrigger, handleCheckImageName)
}

export function* handleCheckImageName({ payload }: any) {
  try {
    const { imageDomainWithId, fileName } = payload
    const imageDomain = imageDomainWithId.split('_')[1]
    const normalizeFileName = imageNameNormalizer(fileName)
    yield put(setIsButtonDisable(imageDomain === i18next.t(`admin:${ACTIVITY_DEFAULT_IMAGE_MESSAGE}`)))
    const images = yield select(getGalleryActivitiesImages)
    const newFileName = `${imageDomain}__${normalizeFileName}`
    // image can represent undefined or immutable Map with next fileds {id,url,ext,mime,fileName,usagePlaces}
    const image = images.find((image: Map<string, any>) => image.get('fileName') === newFileName)
    yield put(setImageForReplace(image))
    if (image !== undefined) {
      showWarning({ content: 'admin:This image name is already used.' })
    }
  } catch (error) {
    console.log(error)
    Sentry.withScope(scope => {
      scope.setExtra('where error was happen', 'handleCheckImageName saga')
      Sentry.captureException(error)
    })
    showError()
  }
}
